import React from 'react';

const Arrow = props => (
	<svg {...props} viewBox="0 0 11 6">
		<polygon
			fill="currentColor"
			points="1328.95642 426 1324 430.956421 1333.97094 430.956421"
			transform="translate(-1324.000000, -426.000000)"
		/>
	</svg>
);

export default Arrow;
